import { render } from "./Whales.vue?vue&type=template&id=0ed26111&scoped=true"
import script from "./Whales.vue?vue&type=script&lang=js"
export * from "./Whales.vue?vue&type=script&lang=js"

import "./Whales.vue?vue&type=style&index=0&id=0ed26111&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed26111"]])

export default __exports__